// 根据 2026-09-13 最新简历的实际职责归纳；具体项目与指标通过支撑经历查看。
export const capabilityModel = {
    "headline": "把方向变成组织能力，让投入形成长期价值。",
    "intro": "以业务判断为起点，统筹技术、资源与人才，对交付质量和业务价值承担责任。",
    "groups": [
        {
            "label": "方向与投入",
            "dimensions": [
                "direction",
                "resources"
            ]
        },
        {
            "label": "体系与组织",
            "dimensions": [
                "technology",
                "organization"
            ]
        },
        {
            "label": "治理与价值",
            "dimensions": [
                "governance",
                "outcomes"
            ]
        }
    ],
    "dimensions": [
        {
            "id": "direction",
            "short": "战略判断",
            "name": "业务方向与产品战略",
            "thesis": "判断值得做的事，\n定义下一阶段的方向。",
            "description": "从业务全局识别机会，把分散需求组织为产品方向、阶段目标与清晰的优先级。",
            "decision": "在业务价值、验证难度与长期潜力之间取舍，确定做什么、何时做、做到什么程度。",
            "mechanism": "以产品路线和阶段评审对齐业务与产研，让投入有依据、推进有边界。",
            "accountability": "对方向的合理性负责，让研发投入回应真实业务需要。",
            "links": [
                {
                    "label": "智能问数",
                    "href": "#resume-project-0"
                },
                {
                    "label": "Aixera 职责",
                    "href": "#resume-experience-aixera"
                }
            ]
        },
        {
            "id": "resources",
            "short": "资源配置",
            "name": "资源配置与投入判断",
            "thesis": "让有限的资源，\n集中到关键目标。",
            "description": "统筹人力、模型与基础设施投入，让产品组合、团队能力和交付节奏彼此匹配。",
            "decision": "权衡自建、采购与复用，平衡当期交付、持续成本和长期能力建设。",
            "mechanism": "把投入测算、优先级和阶段评估结合起来，随验证结果调整资源安排。",
            "accountability": "对投入效率负责，让成本、质量与进度共同支撑目标。",
            "links": [
                {
                    "label": "Lattice 协同与成本",
                    "href": "#resume-project-0"
                },
                {
                    "label": "拳游统筹职责",
                    "href": "#resume-experience-ov"
                }
            ]
        },
        {
            "id": "technology",
            "short": "技术战略",
            "name": "技术战略与体系建设",
            "thesis": "把技术选择，\n变成可持续的能力。",
            "description": "从产品组合和业务演进出发，统筹技术路线、平台架构与关键研发，建设可复用的能力体系。",
            "decision": "确定共用能力与业务定制的边界，在创新速度、可靠性和维护成本之间取舍。",
            "mechanism": "沉淀语言工程、任务编排与偏好对齐的架构原则，通过技术评审、公共能力和场景验证形成团队方法。",
            "accountability": "对技术路线与系统演进负责，让能力可以持续复用和扩展。",
            "links": [
                {
                    "label": "Agent 工程与公共平台",
                    "href": "#project-platform"
                },
                {
                    "label": "企业知识服务",
                    "href": "#project-knowledge"
                }
            ]
        },
        {
            "id": "organization",
            "short": "组织建设",
            "name": "组织建设与人才发展",
            "thesis": "建立能独立判断、\n共同承担结果的团队。",
            "description": "围绕目标组织产品、研发、测试与运营，把跨职能协作转化为清晰的责任关系。",
            "decision": "判断需要哪些能力、由谁承担责任，平衡人才发展与阶段交付。",
            "mechanism": "通过招聘培养、职责分工、方案评审与成员辅导，建立协作和反馈机制。",
            "accountability": "对团队能力与协作质量负责，让成员形成判断并承担交付责任。",
            "links": [
                {
                    "label": "人才评估与业务试用",
                    "href": "#project-talent"
                },
                {
                    "label": "团队知识与新人赋能",
                    "href": "#project-project-knowledge"
                }
            ]
        },
        {
            "id": "governance",
            "short": "治理机制",
            "name": "交付体系与风险治理",
            "thesis": "把质量与风险，\n纳入组织的决策方式。",
            "description": "建立贯穿产品定义、研发验证与交付准入的治理体系，让标准、责任和证据共同约束交付。",
            "decision": "权衡交付速度与质量底线，明确可接受风险、放行条件及升级处理边界。",
            "mechanism": "通过 r0-skill 制定研发 SOP，明确阶段输入输出、质量门禁与放行条件，将问题回流、修复复验和经验沉淀连成流程。",
            "accountability": "对交付质量与风险处置负责，让结果可验收、决策可追溯。",
            "links": [
                {
                    "label": "研发 SOP 与交付体系",
                    "href": "#project-platform"
                },
                {
                    "label": "QA 测试证据",
                    "href": "#project-qa"
                }
            ]
        },
        {
            "id": "outcomes",
            "short": "业务责任",
            "name": "业务价值与持续演进",
            "thesis": "让交付进入业务，\n让反馈决定下一步。",
            "description": "连接业务使用、质量评估与投入判断，把阶段成果沉淀为持续改善的产品和组织能力。",
            "decision": "依据实际使用与验证结果，判断哪些方向继续投入、哪些方案需要调整。",
            "mechanism": "组织业务验收与阶段复盘，把问题反馈、技术资产和改进优先级纳入后续规划。",
            "accountability": "对落地价值与持续改进负责，用实际反馈检验方向和投入。",
            "links": [
                {
                    "label": "知识库评测与应用",
                    "href": "#resume-project-2"
                },
                {
                    "label": "问数业务成果",
                    "href": "#resume-project-0"
                }
            ]
        }
    ]
};
